export default (number: number): boolean => {
  const int64RegExp = /^-?[0-9]{1,18}$/
  return int64RegExp.test(String(number))
}
